import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import DynamicShapes from '../../components/dynamic-shapes';
import { version as rawDesignSystemReactVersion } from '@salesforce/design-system-react/package.json';
import {
    version as sldsVersion,
    slds
} from '@salesforce-ux/design-system/package.json';

const removeDocFixSuffix = version => version.split('-docfix')[0];

export const HomePageLayout = ({ children }) => (
    <div>
        <DynamicShapes x={1170} y={330} />
        <div className="slds-page">
            <div className="slds-container--center slds-container--large">
                <div className="slds-grid--vertical">
                    <section className="hero ">
                        <div className="herotext slds-text-heading--large">
                            <h1
                                className="slds-m-bottom--medium"
                                style={{
                                    maxWidth: '750px',
                                    lineHeight: '1.25'
                                }}
                            >
                                Lightning Design System <i>for</i> React
                            </h1>
                            <div>
                                <small className="slds-grid--vertical-align-center">
                                    <p className="site-releasenumber">
                                        <Link
                                            to="/getting-started/"
                                            className="slds-button slds-button--neutral slds-m-right--small slds-p-horizontal--xx-large slds-p-vertical--xx-small"
                                            style={{ fontSize: '1rem' }}
                                        >
                                            Get Started
                                        </Link>
                                        <span className="divider" /> Latest
                                        release:{' '}
                                        <a
                                            style={{
                                                color: '#fff',
                                                textDecoration: 'underline'
                                            }}
                                            title="Release Notes"
                                            href={`https://github.com/salesforce/design-system-react/releases/tag/v${removeDocFixSuffix(
                                                rawDesignSystemReactVersion
                                            )}`}
                                        >
                                            {' '}
                                            {removeDocFixSuffix(
                                                rawDesignSystemReactVersion
                                            )}
                                        </a>{' '}
                                        | Pairs well with:{' '}
                                        <a
                                            style={{
                                                color: '#fff',
                                                textDecoration: 'underline'
                                            }}
                                            title="SLDS Release Notes"
                                            href="https://lightningdesignsystem.com/"
                                        >
                                            SLDS {slds.name}
                                        </a>{' '}
                                        ({sldsVersion}/{slds.id})
                                    </p>
                                </small>
                            </div>
                        </div>
                    </section>
                    {children}
                </div>
            </div>
        </div>
    </div>
);

HomePageLayout.displayName = 'HomePageLayout';
HomePageLayout.propTypes = {
    children: PropTypes.element.isRequired
};

export default HomePageLayout;

//	<span className="slds-text-heading--large">for React</span>



// WEBPACK FOOTER //
// ./public/src/layouts/home-page-layout/index.jsx